/**
 * HistoryPrimeOnPastePlugin - Primes Lexical history before paste handlers run.
 *
 * Lexical's history only pushes to undoStack when historyState.current !== null.
 * The first 1-2 pastes can fail undo because current is null (timing/race).
 * This plugin runs at COMMAND_PRIORITY_CRITICAL (higher than PasteImagePlugin's HIGH),
 * primes history if needed, then returns false so actual paste handlers run.
 */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useSharedHistoryContext } from '../../context/SharedHistoryContext';
import { PASTE_COMMAND, COMMAND_PRIORITY_CRITICAL } from 'lexical';
import { useEffect } from 'react';

export default function HistoryPrimeOnPastePlugin() {
  const [editor] = useLexicalComposerContext();
  const { historyState } = useSharedHistoryContext() || {};

  useEffect(() => {
    if (!editor || !historyState) return;

    return editor.registerCommand(
      PASTE_COMMAND,
      () => {
        if (
          historyState.current === null &&
          historyState.undoStack.length === 0
        ) {
          try {
            historyState.current = {
              editor,
              editorState: editor.getEditorState(),
            };
          } catch (_e) {
            console.error('[HistoryPrime] Prime failed', _e);
          }
        }
        return false; // Let other paste handlers run
      },
      COMMAND_PRIORITY_CRITICAL
    );
  }, [editor, historyState]);

  return null;
}
